<template>
    <div class="Status flex">
        <WIcon
            :icon="icon"
            :color="iconColor"
            :size="20"
        />
        <WText
            tag="span"
            :size="14"
        >
            {{ text }}
        </WText>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'Status',
    props: {
        icon: VueTypes.string.def('folder'),
        iconColor: VueTypes.string,
        text: VueTypes.string,
    },
}
</script>
<style lang="scss" scoped>
.Status {
    position: relative;

    .WIcon {
        margin-right: 10px;
    }

    .WText {
        line-height: 1.65;
    }
}
</style>
